import React from 'react';
import AudioBookItem from '../../components/AudioBookItem/AudioBookItem';
import style from './AudioEditingSection.module.css';
import mediaItems from '../../jsons/audioEditing.json'


const AudioEditingSection = () => {

  return (
    <div className={style.AudioEditingSectionContainer}>
      {mediaItems.map((item, index) => (
        <AudioBookItem
          key={index}
          type={item.type}
          audioImg={item.image}
          audio={item.source}
        />
      ))}
    </div>
  );
};

export default AudioEditingSection;
